import { createSchema, morphism } from 'morphism';

import { contactSchema } from './contactResponseSchema';

export default {
  upcomingSendsSchema: createSchema(
    {
      docs: source => morphism(contactSchema, source.docs),
      pagination: {
        limit: 'limit',
        page: 'page',
        totalPages: 'totalPages',
        totalDocs: 'totalDocs'
      }
    },
    { undefinedValues: { strip: true } }
  )
};
